import React, { useContext, useMemo } from "react";
import { ProcessContext } from "../../../contexts/ProcessContext";
import { Button } from "@material-ui/core";
import { developOptions } from "../../../config/developOptions";
import { flowTest } from "../../../config/flows/flowTest";
import Text from "./Text";
import { modules } from "../../modules";

export const TEST_BUTTON_ID = "test-button";

export const HIDE_TEST_BUTTON_IN_MODULES = [
  modules.DISABLED.id,
  modules.SLIDER.id,
  modules.TERMS.id,
  modules.DOWNPAYMENT_CALCULATOR.id,
  modules.APPLICATION_INFO.id,
  modules.DOCUMENTATION.id,
  modules.OPTINS_AND_SIGNATURE.id,
  modules.SIGNATURE_URL_REDIRECT.id,
  modules.VALIDATION_LINK.id,
];

export const TestButton = () => {
  const {
    state: { testFlow, currentModuleObject },
    dispatch,
  } = useContext(ProcessContext);

  const isTestButtonAllowedInCurrentStep = useMemo(() => {
    if (!currentModuleObject) return false;

    return !HIDE_TEST_BUTTON_IN_MODULES.includes(currentModuleObject.id);
  }, [currentModuleObject]);

  if (!isTestButtonAllowedInCurrentStep) return null;

  return (
    <Button
      id={TEST_BUTTON_ID}
      variant="outlined"
      aria-label="Autocomplete for testing"
      size="small"
      disabled={testFlow}
      style={{ paddingInline: 6, fontSize: 12, height: 24 }}
      onClick={() => {
        developOptions.USE_FAKE_SERVICES_ON_POST_OR_PATCH = false;
        developOptions.USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS = false;
        developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES = true;
        dispatch({
          type: "UPDATE_PROCESS_CONTEXT",
          payload: {
            currentFlow: flowTest,
            testFlow: true,
            appStarted: false,
            flowMessage: undefined,
            conditionsToBeInitialModuleInFlowChecked: false,
            flowItemIsKO: undefined,
          },
        });
      }}
    >
      <Text tId="AUTOCOMPLETE" />
      {testFlow === true && (
        <i
          className="material-icons-outlined"
          style={{ marginLeft: 3, fontSize: 16 }}
        >
          check
        </i>
      )}
    </Button>
  );
};
